module.exports = __webpack_public_path__ + "static/img/login-bg-shizheng.b4de4972.png";